import z from "zod";
import { mm } from "@inovitas/infra3dsdk";

export const CoordinateSchema = z.object({
  easting: z.number(),
  northing: z.number(),
  height: z.number().optional(),
  epsg: z.number(),
});

export const ImageKeySchemaUUID = z
  .string()
  .refine(
    (val) =>
      /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/.test(
        val
      ),
    { error: "Invalid UUID format" }
  );

export const ImageKeySchemaString = z.string();

// ILatLonFov — type: "pano"
const LatLonFovSchema = z.object({
  type: z.literal("pano"),
  lat: z.number(),
  lon: z.number(),
  fov: z.number(),
});

// IPanZoom — type: "panzoom"
const PanZoomSchema = z.object({
  type: z.literal("panzoom"),
  panX: z.number().optional(),
  panY: z.number().optional(),
  zoom: z.number().optional(),
});

// IPointZoom — type: "coordinate"
const PointZoomSchema = z.object({
  type: z.literal("coordinate"),
  coords: z.array(z.number()),
  mindist: z.number().optional(),
  maxdist: z.number().optional(),
  zoomwindowsize: z.number().optional(),
  withLookAtFeature: z.literal(true).optional(),
  cubeorientation: z.any().optional(),
});

// Discriminated union across all three variants
export const PointToSchema = z.discriminatedUnion("type", [
  LatLonFovSchema,
  PanZoomSchema,
  PointZoomSchema,
]);
